import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

export default function Header() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-colors duration-200 ${
        scrolled || open ? "bg-cream/90 backdrop-blur-xl border-b border-black/5" : "bg-cream"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 lg:px-8">
        <Link to="/" data-testid="header-logo-link" className="shrink-0"><Logo /></Link>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((s) => !s)}
          className="grid h-10 w-10 place-items-center rounded-lg border border-black/10 md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-black/5 bg-cream md:hidden" data-testid="mobile-nav">
          <nav className="mx-auto flex max-w-6xl flex-col px-5 py-3">
            <Link to="/support" data-testid="mobile-nav-support" className="rounded-lg px-3 py-3 text-[15px] font-medium text-charcoal/70">Help</Link>
            <Link to="/privacy" data-testid="mobile-nav-privacy" className="rounded-lg px-3 py-3 text-[15px] font-medium text-charcoal/70">Privacy</Link>
            <Link to="/terms" data-testid="mobile-nav-terms" className="rounded-lg px-3 py-3 text-[15px] font-medium text-charcoal/70">Terms</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
